import React, {useState, useLayoutEffect, useEffect } from "react"
import {
     HeaderContainer,
     Header,
     ImageHeader,
     TextHeader,
     Title,
     ContainerLinkTree,
     LinkElement,
     Button,
     LogoContainer
} from "./linkTreeComponents";
import { StaticImage } from "gatsby-plugin-image";

const Year = new Date().getFullYear();

const Linktree = (props) => {

  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {

    if(typeof window !== "undefined"){

      const updateSize = () => {
      
        setWidth(window.innerWidth);
        setHeight(window.innerHeight);
        console.log(height > width);
      };

      window.addEventListener("resize",updateSize);
    }
  }, []);

    return (
    
    <>

        <ContainerLinkTree portrait={height > width ? true : false}>

             <h2>{props.title}</h2>
             <LinkElement>
               <Button href="https://dentalvipcaracas.com/">VISITAR PÁGINA WEB</Button>
             </LinkElement>

             <LinkElement>
               <Button href="https://t.me/dentalvipcaracas">CONSULTA VÍA TELEGRAM</Button>
             </LinkElement>

             <LinkElement>
               <Button href="https://wa.me/message/C7HBKT2UR5DUL1">CONSULTA VÍA WHATSAPP</Button>
             </LinkElement>

             <LinkElement>
               <Button href="https://m.me/dentalvip">FACEBOOK MESSENGER</Button>
             </LinkElement>
        </ContainerLinkTree>

        <LogoContainer>
             <div className="logos">
               <a href="https://instagram.com/dental_vip">
                  <StaticImage
                      src="../images/a-01.svg"
                      width={50}
                      quality={95}
                      formats={["AUTO", "WEBP", "AVIF"]}
                      alt="Dental VIP Messenger"
                      style={{
                        marginLeft: "10px",
                        marginRight: "10px",
                        marginTop: "20px"
                      }}
                  />
               </a>
             </div>

             <div className="logos">
               <a href="mailto:info@dentalvipcaracas.com">
                  <StaticImage
                      src="../images/b-02.svg"
                      width={50}
                      quality={95}
                      formats={["AUTO", "WEBP", "AVIF"]}
                      alt="Dental VIP Messenger"
                      style={{
                        marginLeft: "10px",
                        marginRight: "10px",
                        marginTop: "20px"
                      }}
                  />
               </a>
             </div>

             <div className="logos">
               <a href="tel:+582122613732">
                  <StaticImage
                      src="../images/c-03.svg"
                      width={50}
                      quality={95}
                      formats={["AUTO", "WEBP", "AVIF"]}
                      alt="Dental VIP Messenger"
                      style={{
                        marginLeft: "10px",
                        marginRight: "10px",
                        marginTop: "20px"
                      }}
                  />
               </a>
             </div>  
          
        </LogoContainer>
       </>);

};

export default Linktree;
